<template>
<a title="Sign in with Google"
  class="google-signin-btn"
  @click="signIn">
  <img src="/common/images/btn_google_normal.png" alt="Sign in with Google">
</a>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: ['buttonActionLabel'],
  computed: {},
  mounted: function () {},
  methods: {
    signIn: async function () {
      const app = this
      this.$firebase.signInGapi()
    }
  }
}
</script>
